export default class {
  constructor() {
    this.images = document.querySelectorAll('.media')

    for (let i = 0; i < this.images.length; i++) {
      this.fixImage(this.images[i])
    }

    this.medias = document.querySelectorAll('img');

    for (let j = 0; j < this.medias.length; j++) {
      this.medias[j].style.opacity = 1;
    }
  }

  fixImage(image) {
    const parent = image.parentElement

    if (parent.classList.contains('hero')) {
      this.processImage(image, parent)
    } else if (parent.parentElement.classList.contains('hero')) {
      this.processImage(image, parent.parentElement)
    } else if (
      !parent.classList.contains('logo') &&
      !parent.parentElement.classList.contains('-brand') &&
      !parent.parentElement.parentElement.classList.contains('-brand') &&
      !parent.parentElement.classList.contains('logo')
    ) {
      this.processImage(image, parent.parentElement)
    }
  }

  processImage(image, parent) {
    parent.style.background = `white url(${image.src}) no-repeat center center`
    parent.style.backgroundSize = 'cover'
    image.style.opacity = 0
  }
}
